import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import EAButton from "./EAButton";
import HtmlTooltip from "@mui/material/Tooltip";
import { Ticket } from "../../../models/Ticket";

interface IProps {
  cancelReservation: boolean;
  setCancelReservation: (value: boolean) => void;
  onResign: () => void;
  exerciseStartTime: number;
  now: number;
  isDesktop: boolean;
  ticket: Ticket | any;
  fullWidth?: boolean;
  variant?: "filled" | "outlined" | "text";
}

const ResignButton: React.FC<IProps> = ({
  cancelReservation,
  setCancelReservation,
  onResign,
  exerciseStartTime,
  now,
  isDesktop,
  ticket,
  fullWidth = false,
  variant = "filled",
}) => {
  const { t } = useTranslation();
  const allowToChangeDate = useSelector((state: State) => state.config.configuration.allowReservedExerciseChange);
  const blockTimeBeforeExercise = useSelector((state: State) => state.config.configuration.blockTimeBeforeExerciseDateChange);

  if (!allowToChangeDate && !ticket.isExerciseSelfService) {
    return null;
  }

  if (cancelReservation) {
    // Sprawdzamy czy zajęcie już się rozpoczęło
    if ((exerciseStartTime < 1e11 ? exerciseStartTime * 1000 : exerciseStartTime) <= now) {
      return (
        <HtmlTooltip
          placement="top"
          arrow
          title={<article dangerouslySetInnerHTML={{ __html: "Rezygnacja jest niedostępna — wydarzenie już się rozpoczęło." }} />}
        >
          <span>
            <EAButton
              title={t("zrezygnuj")}
              onClick={() => setCancelReservation(false)}
              color="error"
              variant={variant}
              disabled
              fullWidth={fullWidth}
            />
          </span>
        </HtmlTooltip>
      );
    }

    // Sprawdzamy czy nie minął czas na rezygnację
    if (now >= exerciseStartTime - blockTimeBeforeExercise * 60_000) {
      return (
        <HtmlTooltip
          placement="top"
          arrow
          title={<article dangerouslySetInnerHTML={{ __html: "Nie możesz już zrezygnować — minął czas przewidziany na zmianę rezerwacji." }} />}
        >
          <span>
            <EAButton
              title={t("zrezygnuj")}
              onClick={() => setCancelReservation(false)}
              color="error"
              variant={variant}
              disabled
              fullWidth={fullWidth}
            />
          </span>
        </HtmlTooltip>
      );
    }

    // Przycisk aktywny - można zrezygnować
    return (
      <EAButton 
        title={t("zrezygnuj")} 
        onClick={() => setCancelReservation(false)} 
        color="error" 
        variant={variant}
        fullWidth={fullWidth}
      />
    );
  }

  // Widok potwierdzenia rezygnacji
  return (
    <div className={`resing-wrapper ${!isDesktop ? "resing-wrapper__mobile" : ""}`}>
      <h5>Czy na pewno chcesz zrezygnować ?</h5>
      <div>
        <EAButton 
          title={t("tak_rezygnuje")} 
          onClick={onResign} 
          color="error" 
          variant="filled" 
        />
        <EAButton 
          title={t("nie")} 
          onClick={() => setCancelReservation(true)} 
          color="error" 
          variant="outlined" 
        />
      </div>
    </div>
  );
};

export default ResignButton;
